
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { DataCollection, GetCollectionParams, GetCollectionObjResult } from './data-collection-service.types';

const TapApiBaseUrl = `/worker/api`;

export const getCollectionObj = (params: GetCollectionParams) => {
    return axios.get<GetCollectionObjResult>(`${TapApiBaseUrl}/data`, { params: params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
            
        });
}

export const getByCode = <T>(code: string) => {
    return axios.get<DataCollection<T>>(`${TapApiBaseUrl}/data/${code}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
            
        });
}